/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Global = __webpack_require__(9),
	    _Global2 = _interopRequireDefault(_Global),
	    _functions = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var global = (0, _functions.getGlobal)(),
	    Pushwoosh = global.Pushwoosh,
	    predefinedCommands = void 0;
	
	if (Pushwoosh) {
	  predefinedCommands = Pushwoosh;
	}
	
	Pushwoosh = new _Global2.default();
	if (Array.isArray(predefinedCommands)) {
	  predefinedCommands.forEach(function (c) {
	    return Pushwoosh.push(c);
	  });
	}
	
	global.Pushwoosh = Pushwoosh;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.getGlobal = getGlobal;
	exports.getVersion = getVersion;
	exports.isSafariBrowser = isSafariBrowser;
	exports.canUseServiceWorkers = canUseServiceWorkers;
	exports.getBrowserType = getBrowserType;
	exports.getBrowserVersion = getBrowserVersion;
	exports.getDeviceName = getDeviceName;
	exports.createUUID = createUUID;
	exports.getPushToken = getPushToken;
	exports.generateHwid = generateHwid;
	exports.getAuthToken = getAuthToken;
	exports.getPublicKey = getPublicKey;
	exports.getPushwooshUrl = getPushwooshUrl;
	function getGlobal() {
	  return Function('return this')(); // eslint-disable-line no-new-func
	}
	
	function getVersion() {
	  return '2.10.1';
	}
	
	function isSafariBrowser() {
	  return typeof safari !== 'undefined' && navigator.userAgent.indexOf('Safari') > -1;
	}
	
	function canUseServiceWorkers() {
	  return navigator && navigator.serviceWorker && 'showNotification' in ServiceWorkerRegistration.prototype && 'PushManager' in window;
	}
	
	function getBrowserType() {
	  if (isSafariBrowser()) {
	    return 10;
	  }
	  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? 12 : 11;
	}
	
	function getBrowserVersion() {
	  var ua = navigator.userAgent,
	      tem = void 0,
	      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	
	
	  if (/trident/i.test(M[1])) {
	    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	    return 'IE ' + (tem[1] || '');
	  }
	
	  if (M[1] === 'Chrome') {
	    tem = ua.match(/\bOPR\/(\d+)/);
	    if (tem != null) {
	      return 'Opera ' + tem[1];
	    }
	  }
	
	  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	  tem = ua.match(/version\/([.\d]+)/i);
	  if (tem != null) {
	    M.splice(1, 1, tem[1]);
	  }
	
	  return M.join(' ');
	}
	
	function getDeviceName() {
	  var userAgent = navigator.userAgent;
	  if (userAgent.match(/Android/i) || userAgent.match(/webOS/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/iPod/i) || userAgent.match(/BlackBerry/i) || userAgent.match(/Windows Phone/i)) {
	    return 'Phone';
	  }
	  return 'PC';
	}
	
	function createUUID(pushToken) {
	  var hexDigits = '0123456789abcdef',
	      s = [];
	
	  for (var i = 0; i < 32; i++) {
	    var charCode = '0';
	    if (pushToken.length - i - 1 >= 0) {
	      charCode = pushToken.charCodeAt(pushToken.length - i - 1);
	    }
	
	    s[i] = hexDigits.substr(charCode % hexDigits.length, 1);
	  }
	  return s.join('');
	}
	
	function getPushToken(pushSubscription) {
	  if (pushSubscription.subscriptionId) {
	    return pushSubscription.subscriptionId;
	  }
	
	  if (getBrowserType() === 12) {
	    return pushSubscription.endpoint;
	  }
	
	  return pushSubscription.endpoint.split('/').pop();
	}
	
	function generateHwid(applicationCode, pushToken) {
	  return applicationCode + '_' + createUUID(pushToken);
	}
	
	function getSubsKey(pushSubscription, key) {
	  var rawKey = pushSubscription.getKey && pushSubscription.getKey(key);
	  return rawKey ? btoa(String.fromCharCode.apply(String, new Uint8Array(rawKey))) : '';
	}
	
	function getAuthToken(pushSubscription) {
	  return getSubsKey(pushSubscription, 'auth');
	}
	
	function getPublicKey(pushSubscription) {
	  return getSubsKey(pushSubscription, 'p256dh');
	}
	
	function getPushwooshUrl(applicationCode) {
	  var subDomain = 'cp';
	  if (!isSafariBrowser() && applicationCode && !~applicationCode.indexOf('.')) {
	    subDomain = applicationCode + '.api';
	  }
	  return 'https://' + subDomain + '.pushwoosh.com/json/1.3/';
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createErrorAPI = createErrorAPI;
	
	var _functions = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var methods = ['doPushwooshApiMethod', 'registerDevice', 'unregisterDevice', 'applicationOpen', 'setTags', 'getTags', 'pushStat'];
	
	function createErrorAPI(error) {
	  return methods.reduce(function (api, methodName) {
	    api[methodName] = function () {
	      return Promise.reject(error);
	    }; // eslint-disable-line no-param-reassign
	    return api;
	  }, {});
	}
	
	var PushwooshAPI = function () {
	  function PushwooshAPI(params) {
	    _classCallCheck(this, PushwooshAPI);
	
	    this.doPushwooshApiMethod = params.doPushwooshApiMethod;
	    this.applicationCode = params.applicationCode;
	    this.hwid = params.hwid;
	    this.pushToken = params.pushToken;
	    this.publicKey = params.publicKey;
	    this.authToken = params.authToken;
	    this.language = params.language;
	  }
	
	  PushwooshAPI.prototype.callAPI = function callAPI(methodName, methodParams) {
	    return this.doPushwooshApiMethod(methodName, _extends({}, methodParams, {
	      application: this.applicationCode,
	      hwid: this.hwid
	    }));
	  };
	
	  PushwooshAPI.prototype.registerDevice = function registerDevice() {
	    return this.callAPI('registerDevice', {
	      push_token: this.pushToken,
	      public_key: this.publicKey,
	      auth_token: this.authToken,
	      language: this.language || 'en',
	      timezone: -new Date().getTimezoneOffset() * 60,
	      device_model: (0, _functions.getBrowserVersion)(),
	      device_name: (0, _functions.getDeviceName)(),
	      device_type: (0, _functions.getBrowserType)()
	    });
	  };
	
	  PushwooshAPI.prototype.unregisterDevice = function unregisterDevice() {
	    return this.callAPI('unregisterDevice');
	  };
	
	  PushwooshAPI.prototype.applicationOpen = function applicationOpen() {
	    return this.callAPI('applicationOpen', {
	      push_token: this.pushToken,
	      timezone: -new Date().getTimezoneOffset() * 60,
	      device_type: (0, _functions.getBrowserType)()
	    });
	  };
	
	  PushwooshAPI.prototype.setTags = function setTags(tags) {
	    return this.callAPI('setTags', { tags: tags });
	  };
	
	  PushwooshAPI.prototype.getTags = function getTags() {
	    return this.callAPI('getTags');
	  };
	
	  PushwooshAPI.prototype.pushStat = function pushStat(hash) {
	    return this.callAPI('pushStat', { hash: hash });
	  };
	
	  PushwooshAPI.create = function create(subscription, applicationCode, doPushwooshApiMethod, language) {
	    var pushToken = (0, _functions.getPushToken)(subscription);
	
	    return new PushwooshAPI({
	      doPushwooshApiMethod: doPushwooshApiMethod,
	      applicationCode: applicationCode,
	      hwid: (0, _functions.generateHwid)(applicationCode, pushToken),
	      pushToken: pushToken,
	      publicKey: (0, _functions.getPublicKey)(subscription),
	      authToken: (0, _functions.getAuthToken)(subscription),
	      language: language
	    });
	  };
	
	  return PushwooshAPI;
	}();
	
	exports.default = PushwooshAPI;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PushwooshError = function (_Error) {
	  _inherits(PushwooshError, _Error);
	
	  function PushwooshError(text, code) {
	    _classCallCheck(this, PushwooshError);
	
	    var _this = _possibleConstructorReturn(this, _Error.call(this, text));
	
	    _this.code = code;
	    return _this;
	  }
	
	  return PushwooshError;
	}(Error);
	
	PushwooshError.codes = {
	  userDenied: 'user_denied'
	};
	
	exports.default = PushwooshError;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var keyTagsWasSetted = exports.keyTagsWasSetted = 'pushwooshDefaultTagsWasSetted';
	var keyWasRegistered = exports.keyWasRegistered = 'pushwooshWasRegistered';
	var keyApplicationCode = exports.keyApplicationCode = 'pushwooshApplicationCode';
	
	var defaultWorkerUrl = exports.defaultWorkerUrl = '/pushwoosh-service-worker-light.js';
	var defaultWorkerSecondUrl = exports.defaultWorkerSecondUrl = '/pushwoosh-service-worker-dark.js';
	
	var keyDefaultNotificationTitle = exports.keyDefaultNotificationTitle = 'pushwooshDefaultNotificationTitle';
	var keyDefaultNotificationImage = exports.keyDefaultNotificationImage = 'pushwooshDefaultNotificationImage';
	var keyDefaultNotificationUrl = exports.keyDefaultNotificationUrl = 'pushwooshDefaultNotificationUrl';
	var defaultNotificationTitle = exports.defaultNotificationTitle = 'Pushwoosh notification';
	var defaultNotificationImage = exports.defaultNotificationImage = 'https://cp.pushwoosh.com/img/logo-medium.png';
	var defaultNotificationUrl = exports.defaultNotificationUrl = '/';
	
	var keyWorkerSDKVersion = exports.keyWorkerSDKVersion = 'pushwooshWorkerSDKVersion';
	
	var keyLanguage = exports.keyLanguage = 'pushwooshLanguage';
	
	var keyLastSentAppOpen = exports.keyLastSentAppOpen = 'pushwooshLastSentAppOpen';

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var instance = void 0;
	
	function getInstance() {
	  return new Promise(function (resolve, reject) {
	    if (instance) {
	      resolve(instance);
	    } else {
	      var request = indexedDB.open('PUSHWOOSH_SDK_STORE', 2);
	      request.onsuccess = function (event) {
	        var database = event.target.result;
	        if (instance) {
	          database.close();
	          resolve(instance);
	        } else {
	          instance = database;
	          resolve(database);
	        }
	      };
	      request.onerror = function (event) {
	        reject(event);
	      };
	      request.onupgradeneeded = function (event) {
	        var database = event.target.result;
	        database.createObjectStore('keyValue', {
	          keyPath: 'key'
	        });
	      };
	      request.onversionchange = function (event) {
	        console.info('The database is about to be deleted.', event); // eslint-disable-line
	      };
	    }
	  });
	}
	
	function createKeyValue(name) {
	  return {
	    get: function get(key) {
	      return getInstance().then(function (database) {
	        return new Promise(function (resolve, reject) {
	          var request = database.transaction(name).objectStore(name).get(key);
	          request.onsuccess = function () {
	            var result = request.result;
	
	            resolve(result && result.value);
	          };
	          request.onerror = function () {
	            reject(request.errorCode);
	          };
	        });
	      });
	    },
	    getAll: function getAll() {
	      return getInstance().then(function (database) {
	        return new Promise(function (resolve, reject) {
	          var result = {},
	              cursor = database.transaction(name).objectStore(name).openCursor();
	
	          cursor.onsuccess = function (event) {
	            var cursorResult = event.target.result;
	            if (cursorResult) {
	              result[cursorResult.key] = cursorResult.value.value;
	              cursorResult.continue();
	            } else {
	              resolve(result);
	            }
	          };
	          cursor.onerror = function () {
	            reject(cursor.errorCode);
	          };
	        });
	      });
	    },
	    set: function set(key, value) {
	      return getInstance().then(function (database) {
	        return new Promise(function (resolve, reject) {
	          var request = database.transaction([name], 'readwrite').objectStore(name).put({ key: key, value: value });
	          request.onsuccess = function () {
	            resolve(key);
	          };
	          request.onerror = function (e) {
	            reject(e);
	          };
	        });
	      });
	    }
	  };
	}
	
	var keyValue = exports.keyValue = createKeyValue('keyValue');

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var levels = {
	  error: 1,
	  info: 2,
	  debug: 3
	};
	
	var Logger = function () {
	  function Logger(level) {
	    var _this = this;
	
	    _classCallCheck(this, Logger);
	
	    this.setLevel(level);
	
	    Object.keys(levels).forEach(function (k) {
	      var n = levels[k];
	      _this[k] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        if (n <= _this.n) {
	          var _console;
	
	          (_console = console).info.apply(_console, [k].concat(args)); // eslint-disable-line no-console
	          console.trace('trace'); // eslint-disable-line no-console
	        }
	      };
	    });
	  }
	
	  Logger.prototype.setLevel = function setLevel(level) {
	    if (!levels[level]) {
	      level = 'info'; // eslint-disable-line no-param-reassign
	    }
	    this.n = levels[level];
	  };
	
	  return Logger;
	}();
	
	exports.default = Logger;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _eventemitter = __webpack_require__(13),
	    _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseInit = function BaseInit(params) {
	  var _this = this;
	
	  _classCallCheck(this, BaseInit);
	
	  this._params = params;
	  this.ee = new _eventemitter2.default();
	  Object.keys(params).forEach(function (k) {
	    _this[k] = params[k];
	  });
	  this.logger.debug('inited with params', params);
	};
	
	exports.default = BaseInit;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createDoApiXHR;
	
	var _PushwooshError = __webpack_require__(3),
	    _PushwooshError2 = _interopRequireDefault(_PushwooshError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDoApiXHR(pushwooshUrl, logger) {
	  return function doApiXHR(methodName, request) {
	    logger.debug('Performing ' + methodName + ' call to Pushwoosh with arguments: ' + JSON.stringify(request));
	    return new Promise(function (resolve, reject) {
	      try {
	        var xhr = new XMLHttpRequest(),
	            url = pushwooshUrl + methodName,
	            params = { request: request };
	
	
	        xhr.open('POST', url, true);
	        xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
	        xhr.onload = function xhrOnLoad() {
	          if (this.status == 200) {
	            // eslint-disable-line eqeqeq
	            var response = JSON.parse(this.responseText);
	            if (response.status_code == 200) {
	              // eslint-disable-line eqeqeq
	              logger.debug(methodName + ' call to Pushwoosh has been successful');
	              resolve(response.response);
	            } else {
	              var logText = new _PushwooshError2.default('Error occurred during the ' + methodName + ' call to Pushwoosh: ' + response.status_message);
	              logger.error(logText);
	              reject(logText);
	            }
	          } else {
	            var _logText = new _PushwooshError2.default('Error occurred, status code: ' + this.status);
	            logger.error(_logText);
	            reject(_logText);
	          }
	        };
	        xhr.onerror = function xhrOnError(e) {
	          var logText = new _PushwooshError2.default('Pushwoosh response to ' + methodName + ' call in not ok: ' + e);
	          logger.error(logText);
	          reject(logText);
	        };
	        xhr.send(JSON.stringify(params));
	      } catch (e) {
	        var logText = new _PushwooshError2.default('Exception while ' + methodName + ' the device: ' + e);
	        logger.error(logText);
	        reject(logText);
	      }
	    });
	  };
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _storage = __webpack_require__(5),
	    _functions = __webpack_require__(1),
	    _Logger = __webpack_require__(6),
	    _Logger2 = _interopRequireDefault(_Logger),
	    _SafariInit = __webpack_require__(10),
	    _SafariInit2 = _interopRequireDefault(_SafariInit),
	    _WorkerInit = __webpack_require__(11),
	    _WorkerInit2 = _interopRequireDefault(_WorkerInit),
	    _API = __webpack_require__(2),
	    _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isSafari = (0, _functions.isSafariBrowser)(),
	    canUseSW = (0, _functions.canUseServiceWorkers)();
	
	
	function findHeader(headers, fh) {
	  var val = '';
	  for (var _iterator = headers.entries(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var h = _ref;
	
	    if (h[0].toLowerCase() === fh) {
	      val = h[1];
	    }
	  }
	  return val;
	}
	
	var PushwooshGlobal = function () {
	  function PushwooshGlobal() {
	    _classCallCheck(this, PushwooshGlobal);
	
	    this._commands = [];
	    this._keyValue = _storage.keyValue;
	  }
	
	  PushwooshGlobal.prototype._init = function _init() {
	    var _this = this,
	        initPromise = this._auto ? this._initer.initSubscribe() : this._initer.initApi();
	
	    this._initPromise = initPromise.catch(function (err) {
	      _this._logger.debug('Error was caught in browser init', err);
	      return (0, _API.createErrorAPI)(err);
	    }).then(function (api) {
	      return _this.api = api;
	    }) // eslint-disable-line no-return-assign
	    .then(function () {
	      // eslint-disable-line consistent-return
	      var lastSentTime = Number(localStorage.getItem(_constants.keyLastSentAppOpen)),
	          curTime = Date.now();
	
	      if (curTime - lastSentTime > 3600000) {
	        localStorage.setItem(_constants.keyLastSentAppOpen, curTime);
	        return _this.api.applicationOpen().then(function () {
	          return _this._logger.debug('applicationOpen sent successfully');
	        }, function (err) {
	          return _this._logger.debug('applicationOpen sent with error', err);
	        });
	      }
	    }).then(function () {
	      return _this._commands.forEach(function (cmd) {
	        return _this._runCmd(cmd);
	      });
	    });
	  };
	
	  PushwooshGlobal.prototype.init = function init(params) {
	    var applicationCode = params.applicationCode,
	        safariWebsitePushID = params.safariWebsitePushID,
	        _params$serviceWorker = params.serviceWorkerUrl,
	        serviceWorkerUrl = _params$serviceWorker === undefined ? _constants.defaultWorkerUrl : _params$serviceWorker,
	        _params$serviceWorker2 = params.serviceWorkerSecondUrl,
	        serviceWorkerSecondUrl = _params$serviceWorker2 === undefined ? _constants.defaultWorkerSecondUrl : _params$serviceWorker2,
	        logLevel = params.logLevel,
	        _params$pushwooshUrl = params.pushwooshUrl,
	        pushwooshUrl = _params$pushwooshUrl === undefined ? (0, _functions.getPushwooshUrl)(applicationCode) : _params$pushwooshUrl,
	        defaultNotificationTitle = params.defaultNotificationTitle,
	        defaultNotificationImage = params.defaultNotificationImage,
	        defaultNotificationUrl = params.defaultNotificationUrl,
	        _params$autoSubscribe = params.autoSubscribe,
	        autoSubscribe = _params$autoSubscribe === undefined ? true : _params$autoSubscribe;
	
	    this._initParams = params;
	    this._auto = autoSubscribe;
	    this._logger = new _Logger2.default(logLevel);
	    if (!(isSafari && (0, _functions.getDeviceName)() === 'PC' || canUseSW)) {
	      this._logger.info('This browser does not support pushes');
	      return;
	    }
	    if (!applicationCode) {
	      throw new Error('no application code');
	    }
	
	    if (isSafari) {
	      if (safariWebsitePushID) {
	        this._initer = new _SafariInit2.default({
	          webSitePushID: safariWebsitePushID,
	          pushwooshUrl: pushwooshUrl,
	          applicationCode: applicationCode,
	          logger: this._logger
	        });
	      }
	    } else if (canUseSW) {
	      if (serviceWorkerUrl) {
	        this._initer = new _WorkerInit2.default({
	          workerUrl: serviceWorkerUrl,
	          workerSecondUrl: serviceWorkerSecondUrl,
	          pushwooshUrl: pushwooshUrl,
	          applicationCode: applicationCode,
	          defaultNotificationTitle: defaultNotificationTitle,
	          defaultNotificationImage: defaultNotificationImage,
	          defaultNotificationUrl: defaultNotificationUrl,
	          logger: this._logger
	        });
	      }
	    }
	    if (this._initer) {
	      this._init();
	    } else {
	      this._logger.info('Browser has not been configured');
	    }
	  };
	
	  PushwooshGlobal.prototype._runCmd = function _runCmd(func) {
	    return this._initPromise.then(func);
	  };
	
	  PushwooshGlobal.prototype._cmdInit = function _cmdInit(params) {
	    var _this2 = this;
	
	    if (document.readyState === 'complete') {
	      this.init(params);
	    } else {
	      window.addEventListener('load', function () {
	        return _this2.init(params);
	      });
	    }
	  };
	
	  PushwooshGlobal.prototype._runOrPush = function _runOrPush(clb) {
	    if (this._initPromise) {
	      this._runCmd(clb);
	    } else {
	      this._commands.push(clb);
	    }
	  };
	
	  PushwooshGlobal.prototype.push = function push(cmd) {
	    var _this3 = this;
	
	    if (typeof cmd === 'function') {
	      this._runOrPush(function () {
	        return cmd(_this3.api);
	      });
	    } else if (Array.isArray(cmd)) {
	      switch (cmd[0]) {
	        case 'init':
	          this._cmdInit(cmd[1]);
	          break;
	        case 'subscribe':
	          this._runOrPush(function () {
	            cmd[1](_this3._initer.initSubscribe());
	          });
	          break;
	        case 'unsubscribe':
	          this._runOrPush(function () {
	            cmd[1](_this3._initer.unsubscribe());
	          });
	          break;
	        default:
	          throw new Error('unknown command');
	      }
	    } else {
	      throw new Error('invalid command');
	    }
	  };
	
	  PushwooshGlobal.prototype._debug = function _debug() {
	    var debugFn = console.info.bind(console),
	        initerParams = this._initer._params,
	        jsContentType = 'application/javascript',
	        links = document.getElementsByTagName('link'),
	        checkUrlFn = function checkUrlFn(text, url, type) {
	      fetch(url).then(function (resp) {
	        if (resp.status === 200) {
	          var contentType = findHeader(resp.headers, 'content-type');
	          debugFn(text, contentType.indexOf(type) > -1 ? 'url ' + url + ' is ok' : 'url ' + url + ' has WRONG Content-Type \'' + contentType + '\'');
	        } else {
	          debugFn(text, 'error: url ' + url + ' loaded with status ' + resp.status);
	        }
	      }).catch(function (e) {
	        return debugFn(text, e);
	      });
	    },
	        manifestFounded = false; // eslint-disable-line
	    // eslint-disable-line
	
	
	    debugFn('version', (0, _functions.getVersion)());
	    debugFn('initer params', initerParams);
	    checkUrlFn('workerUrl', '' + location.origin + initerParams.workerUrl, jsContentType);
	    checkUrlFn('workerSecondUrl', '' + location.origin + initerParams.workerSecondUrl, jsContentType);
	    for (var i = 0; i < links.length; ++i) {
	      if (links[i].rel === 'manifest') {
	        checkUrlFn('manifest', links[i].href, 'application/json');
	        manifestFounded = true;
	      }
	    }
	    if (!manifestFounded) {
	      debugFn('Error: manifest not found.');
	    }
	    this._keyValue.getAll().then(function (res) {
	      return debugFn('keyValues', res);
	    });
	  };
	
	  return PushwooshGlobal;
	}();
	
	exports.default = PushwooshGlobal;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BaseInit2 = __webpack_require__(7),
	    _BaseInit3 = _interopRequireDefault(_BaseInit2),
	    _createDoApiXHR = __webpack_require__(8),
	    _createDoApiXHR2 = _interopRequireDefault(_createDoApiXHR),
	    _API = __webpack_require__(2),
	    _API2 = _interopRequireDefault(_API),
	    _PushwooshError = __webpack_require__(3),
	    _PushwooshError2 = _interopRequireDefault(_PushwooshError),
	    _functions = __webpack_require__(1),
	    _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PushwooshSafari = function (_BaseInit) {
	  _inherits(PushwooshSafari, _BaseInit);
	
	  function PushwooshSafari() {
	    _classCallCheck(this, PushwooshSafari);
	
	    return _possibleConstructorReturn(this, _BaseInit.apply(this, arguments));
	  }
	
	  PushwooshSafari.prototype.getPermission = function getPermission() {
	    return window.safari.pushNotification.permission(this.webSitePushID);
	  };
	
	  PushwooshSafari.prototype.initSubscribe = function initSubscribe() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.checkRemotePermission(_this2.getPermission());
	    }, 0);
	    return new Promise(function (resolve, reject) {
	      _this2.ee.once('success', function () {
	        resolve(_this2.api);
	      });
	      _this2.ee.once('failure', reject);
	    });
	  };
	
	  PushwooshSafari.prototype.unsubscribe = function unsubscribe() {
	    return this.initApi().then(function (api) {
	      return api.unregisterDevice();
	    });
	  };
	
	  PushwooshSafari.prototype.initApi = function initApi() {
	    var _this3 = this;
	
	    return Promise.resolve().then(function () {
	      var permissionData = _this3.getPermission();
	      if (permissionData.permission === 'denied') {
	        var err = new _PushwooshError2.default('The user said no.', _PushwooshError2.default.codes.userDenied);
	        _this3.logger.error(err);
	        throw err;
	      }
	      if (!permissionData.deviceToken) {
	        throw new _PushwooshError2.default('permissionData.deviceToken is empty');
	      }
	      var hwid = permissionData.deviceToken.toLowerCase();
	      _this3.api = new _API2.default({
	        doPushwooshApiMethod: (0, _createDoApiXHR2.default)(_this3.pushwooshUrl, _this3.logger),
	        applicationCode: _this3.applicationCode,
	        hwid: hwid,
	        pushToken: hwid.toUpperCase()
	      });
	      _this3.sendPushStat();
	      return _this3.api;
	    });
	  };
	
	  PushwooshSafari.prototype.checkRemotePermission = function checkRemotePermission(permissionData) {
	    var _this4 = this;
	
	    this.logger.debug('permissionData', permissionData);
	
	    if (permissionData.permission === 'default') {
	      this.logger.debug('This is a new web service URL and its validity is unknown.');
	      window.safari.pushNotification.requestPermission(this.pushwooshUrl + 'safari', this.webSitePushID, { application: this.applicationCode }, function (perm) {
	        return _this4.checkRemotePermission(perm);
	      });
	    } else if (permissionData.permission === 'denied') {
	      var err = new _PushwooshError2.default('The user said no.', _PushwooshError2.default.codes.userDenied);
	      this.logger.error(err);
	      this.ee.emit('failure', err);
	    } else if (permissionData.permission === 'granted') {
	      this.logger.debug('The web service URL is a valid push provider, and the user said yes.');
	      this.initApi().then(function () {
	        return _this4.setDefaultTags();
	      }).then(function () {
	        return _this4.ee.emit('success');
	      });
	    }
	  };
	
	  PushwooshSafari.prototype.setDefaultTags = function setDefaultTags() {
	    var _this5 = this;
	
	    return Promise.resolve().then(function () {
	      // eslint-disable-line consistent-return
	      var keyTagsWasSettedValue = (0, _functions.getBrowserVersion)() + '_' + _this5.api.hwid + '_' + (0, _functions.getVersion)();
	      if (localStorage.getItem(_constants.keyTagsWasSetted) !== keyTagsWasSettedValue) {
	        localStorage.setItem(_constants.keyTagsWasSetted, keyTagsWasSettedValue);
	        return _this5.api.setTags({
	          // eslint-disable-next-line quote-props
	          'Language': navigator.language || 'en',
	          'Device Model': (0, _functions.getBrowserVersion)(),
	          'Device Name': (0, _functions.getDeviceName)()
	        });
	      }
	    });
	  };
	
	  PushwooshSafari.prototype.sendPushStat = function sendPushStat() {
	    var _this6 = this;
	
	    try {
	      var hashReg = /#P(.*)/,
	          hash = decodeURIComponent(document.location.hash);
	
	
	      if (hashReg.test(hash)) {
	        this.api.pushStat(hashReg.exec(hash)[1]).then(function () {
	          return _this6.logger.debug('Push stat sent successfully');
	        });
	      }
	    } catch (e) {
	      this.logger.info('error send push stat: ' + e);
	    }
	  };
	
	  return PushwooshSafari;
	}(_BaseInit3.default);
	
	exports.default = PushwooshSafari;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _storage = __webpack_require__(5),
	    _BaseInit2 = __webpack_require__(7),
	    _BaseInit3 = _interopRequireDefault(_BaseInit2),
	    _createDoApiXHR = __webpack_require__(8),
	    _createDoApiXHR2 = _interopRequireDefault(_createDoApiXHR),
	    _API = __webpack_require__(2),
	    _API2 = _interopRequireDefault(_API),
	    _PushwooshError = __webpack_require__(3),
	    _PushwooshError2 = _interopRequireDefault(_PushwooshError),
	    _functions = __webpack_require__(1),
	    _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PushwooshWorker = function (_BaseInit) {
	  _inherits(PushwooshWorker, _BaseInit);
	
	  function PushwooshWorker() {
	    _classCallCheck(this, PushwooshWorker);
	
	    return _possibleConstructorReturn(this, _BaseInit.apply(this, arguments));
	  }
	
	  PushwooshWorker.prototype.initSubscribe = function initSubscribe() {
	    var _this2 = this;
	
	    return navigator.serviceWorker.getRegistration().then(function (serviceWorkerRegistration) {
	      _this2.logger.debug('sw', serviceWorkerRegistration);
	      if (!serviceWorkerRegistration || serviceWorkerRegistration.installing == null) {
	        return _this2.registerSW();
	      }
	      return serviceWorkerRegistration;
	    }).then(function (serviceWorkerRegistration) {
	      return _this2.subscribeForPushes(serviceWorkerRegistration);
	    }).then(function () {
	      return _this2.api;
	    });
	  };
	
	  PushwooshWorker.prototype.unsubscribe = function unsubscribe() {
	    return Promise.all([this.initApi(), navigator.serviceWorker.getRegistration().then(function (reg) {
	      return reg.pushManager.getSubscription();
	    })]).then(function (_ref) {
	      var api = _ref[0],
	          subs = _ref[1];
	
	      return api.unregisterDevice().then(function () {
	        return subs.unsubscribe();
	      });
	    });
	  };
	
	  PushwooshWorker.prototype.initApi = function initApi() {
	    var _this3 = this;
	
	    return Promise.all([_storage.keyValue.set(_constants.keyApplicationCode, this.applicationCode), _storage.keyValue.set(_constants.keyDefaultNotificationTitle, this.defaultNotificationTitle), _storage.keyValue.set(_constants.keyDefaultNotificationImage, this.defaultNotificationImage), _storage.keyValue.set(_constants.keyDefaultNotificationUrl, this.defaultNotificationUrl), _storage.keyValue.set(_constants.keyLanguage, navigator.language)]).then(function () {
	      if (Notification.permission === 'denied') {
	        var err = new _PushwooshError2.default('The user has blocked notifications.', _PushwooshError2.default.codes.userDenied);
	        _this3.logger.error(err);
	        throw err;
	      }
	      return navigator.serviceWorker.getRegistration();
	    }).then(function (serviceWorkerRegistration) {
	      if (!serviceWorkerRegistration) {
	        var err = new _PushwooshError2.default('No serviceWorkerRegistration');
	        _this3.logger.error(err);
	        throw err;
	      }
	      if (_this3.workerSecondUrl && serviceWorkerRegistration.active) {
	        return _storage.keyValue.get(_constants.keyWorkerSDKVersion).then(function (workerSDKVersion) {
	          var curVersion = (0, _functions.getVersion)();
	          _this3.logger.debug('workerSDKVersion===curVersion', workerSDKVersion, curVersion);
	          if (workerSDKVersion !== curVersion) {
	            _this3.logger.debug('re-register for new version');
	            return _this3.registerSW(('' + serviceWorkerRegistration.active.scriptURL).indexOf(_this3.workerUrl) > -1);
	          }
	          return serviceWorkerRegistration;
	        });
	      }
	      return serviceWorkerRegistration;
	    }).then(function (serviceWorkerRegistration) {
	      _this3.logger.debug('sw', serviceWorkerRegistration);
	      return serviceWorkerRegistration.pushManager.getSubscription();
	    }).then(function (subscription) {
	      if (!subscription) {
	        var err = new _PushwooshError2.default('No subscription');
	        _this3.logger.error(err);
	        throw err;
	      }
	      _this3.api = _API2.default.create(subscription, _this3.applicationCode, (0, _createDoApiXHR2.default)(_this3.pushwooshUrl, _this3.logger), navigator.language);
	      return _this3.api;
	    });
	  };
	
	  PushwooshWorker.prototype.getWorkerUrl = function getWorkerUrl(second) {
	    return (second ? this.workerSecondUrl : this.workerUrl) + '?applicationCode=' + this.applicationCode;
	  };
	
	  PushwooshWorker.prototype.registerSW = function registerSW(second) {
	    this.logger.debug('register worker', second);
	    return navigator.serviceWorker.register(this.getWorkerUrl(second));
	  };
	
	  PushwooshWorker.prototype.subscribeForPushes = function subscribeForPushes() {
	    var _this4 = this;
	
	    return navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
	      return serviceWorkerRegistration.pushManager.getSubscription().then(function (subscription) {
	        if (!subscription) {
	          return serviceWorkerRegistration.pushManager.subscribe({
	            userVisibleOnly: true
	          });
	        }
	        return subscription;
	      }).then(function () {
	        return _this4.register();
	      }).catch(function (e) {
	        var err = void 0;
	        if (Notification.permission === 'denied') {
	          err = new _PushwooshError2.default('Permission for Notifications was denied.', _PushwooshError2.default.codes.userDenied);
	        } else {
	          err = 'Unable to subscribe to push: ' + e;
	        }
	        _this4.logger.error(err);
	        throw err;
	      });
	    });
	  };
	
	  PushwooshWorker.prototype.register = function register() {
	    var _this5 = this;
	
	    return this.initApi().then(function () {
	      // eslint-disable-line consistent-return
	      var api = _this5.api,
	          keyWasRegisteredValue = api.hwid + '_' + (0, _functions.getVersion)();
	      if (localStorage.getItem(_constants.keyWasRegistered) !== keyWasRegisteredValue) {
	        localStorage.setItem(_constants.keyWasRegistered, keyWasRegisteredValue);
	        return api.registerDevice();
	      }
	    });
	  };
	
	  return PushwooshWorker;
	}(_BaseInit3.default);
	
	exports.default = PushwooshWorker;

/***/ },
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// pushwoosh-web-notifications.js